import React from 'react';
import { Form } from 'react-bootstrap';
import CurrencyFormat from 'react-currency-format';

const Control = (props) => <Form.Control {...props} />;

const Currency = (props) => (
  <CurrencyFormat
    customInput={Control}
    thousandSeparator="."
    decimalSeparator=","
    prefix="R$ "
    maxLength={17}
    max="999999999.99"
    fixedDecimalScale={true}
    decimalScale={2}
    {...props}
  />
);

const DollarCurrency = (props) => (
  <CurrencyFormat
    customInput={Control}
    thousandSeparator=","
    decimalSeparator="."
    prefix="$ "
    maxLength={17}
    max="999999999.99"
    fixedDecimalScale={true}
    decimalScale={2}
    {...props}
  />
);

const EuroCurrency = (props) => (
  <CurrencyFormat
    customInput={Control}
    thousandSeparator="."
    decimalSeparator=","
    prefix="€ "
    maxLength={17}
    max="999999999.99"
    fixedDecimalScale={true}
    decimalScale={2}
    {...props}
  />
);

const currencyReverse = (currency) => {
  if (typeof currency === 'number') return currency;

  if(currency.match(/\$/) && !currency.match(/\R/)){
    return parseFloat(  
      currency
        .replace(/\,/g, '')
        .replace(/[^0-9\.]+/g, '')
    );
  }
  return parseFloat(
    currency
        .replace(/\./g, '')
        .replace(',', '.')
        .replace(/[^0-9\.]+/g, '')
    
  );
};

const CurrencyPlainText = (props) => (
  <Currency
    plaintext
    readOnly
    className="text-center align-middle"
    style={{ padding: '0px' }}
    tabIndex="-1"
    {...props}
  />
);

const CurrencyEuroPlainText = (props) => (
  <EuroCurrency
    plaintext
    readOnly
    className="text-center align-middle"
    style={{ padding: '0px' }}
    tabIndex="-1"
    {...props}
  />
);

const CurrencyDollarPlainText = (props) => (
  <DollarCurrency
    plaintext
    readOnly
    className="text-center align-middle"
    style={{ padding: '0px' }}
    tabIndex="-1"
    {...props}
  />
);

export {
  currencyReverse,
  CurrencyPlainText,
  Currency,
  DollarCurrency,
  EuroCurrency,
  CurrencyDollarPlainText,
  CurrencyEuroPlainText,
};

export default Currency;
